import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { ToasterService } from 'angular5-toaster';
import { ModalComponent } from "../modal.component";
import { UserTicket, UserTicketTrip } from "../../core/userTicket";
import { TramApiService } from "../../tram-api.service";
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
    selector: 'recover-password-email',
    templateUrl: './recover-password-email.component.html',
    styleUrls: ['./recover-password-email.component.scss']
})
export class RecoverPasswordEmailComponent implements OnInit {
    @Input() email: string;

    @ViewChild('modal') modal: ModalComponent;

    isLoading: boolean = false;
    emailForm: FormGroup;

    constructor(
        private api: TramApiService,
        private formBuilder: FormBuilder,
        private toaster: ToasterService) {
    }

    ngOnInit() {
        this.initForms();
    }

    open() {
        if (this.modal.isOpened) return;

        this.modal.open();
        
        if (this.emailForm) {
            const emailControl = this.emailForm.get('email');
            emailControl.setValue(this.email);
        }
    }

    send(email: string) {
        this.isLoading = true;

        this.api.initResetPassword(email)
            .then(() => {
                this.isLoading = false;

                this.toaster.pop('success', null, 'Ссылка для восстановления скоро придет на почту. Проверьте почту.');

                this.modal.close();
            })
            .catch(err => this.handleError(err));
    }

    private initForms() {
        this.emailForm = this.formBuilder.group({
            email: [null, [
                Validators.required,
                Validators.email
            ]]
        });
    }

    private handleError(error: HttpErrorResponse | string) {
        this.isLoading = false;

        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/account/recover-password-email.component.ts